// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/sidebar/style.less
// module id = 367
// module chunks = 0